import React from 'react';
import '../styles/MainSection.css';
import Header from '../components/Header';
import LoggedBanner from '../components/LoggedBanner';

import { useNavigate, Link } from 'react-router-dom';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

function Assets() {

  const navigate = useNavigate();
  
  const navigating = (route) => {
    navigate(route); // Navigate to the About page
  }
    
  return (
    <div className="App">
      
      <Header />
      <LoggedBanner />

      
      <div className="logged-dashboard-width flexing_content flex_container nopaddding-small">
        <div className="main-dashboard-section column_100 margin-bottom-30"> 
          <div className="main-dashboard-section-inner dark-blue-background group clearfix">
            <div className="main-dashboard-section-title group clearfix">

              <h4 className="title white-text text-left">
                 My Assets
              </h4>

              <Table className="the-table-content">
                  <Thead>
                    <Tr>
                      <Th>Asset</Th>
                      <Th>Amount</Th>
                      <Th>Cost Price</Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>Cusd</Td>
                      <Td>200</Td>
                      <Td>$1.23</Td>
                      <Td  className="text-right">
                        <span className="button margin-left-bottom-10-1">Options</span>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>Usdt</Td>
                      <Td>1000</Td>
                      <Td>$1.23</Td>
                      <Td className="text-right">
                       <span className="button margin-left-bottom-10-1">Options</span>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>BTC</Td>
                      <Td>5</Td>
                      <Td>$98703</Td>
                      <Td className="text-right">
                        <span className="button margin-left-bottom-10-1">Options</span>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
            </div>
          </div> 
        </div>
      </div>

    </div>
  );
}

export default Assets;
